import * as React from 'react'

const SvgIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width || '122'}
    height={props.height || '90'}
    fill='none'
    viewBox='0 0 122 90'
    {...props}
  >
    <g fill='#1D1D1F' clipPath='url(#clip0_6260_22985)'>
      <path d='M29.469 60.652H0V90h29.469zM76.814 0C51.864 0 31.63 20.152 31.63 45s20.235 45 45.185 45S122 69.848 122 45 101.764 0 76.814 0m0 73.135c-15.599 0-28.25-12.58-28.25-28.116 0-15.534 12.632-28.134 28.23-28.134 15.6 0 28.251 12.58 28.251 28.115s-12.652 28.135-28.23 28.135'></path>
    </g>
    <defs>
      <clipPath id='clip0_6260_22985'>
        <path fill='#fff' d='M0 0h122v90H0z'></path>
      </clipPath>
    </defs>
  </svg>
)

export default SvgIcon
